/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoucherStatus } from './voucher-status';


export interface TransazioneVoucherSpendResponseDTO { 
    id_transazione?: string;
    residuo?: number;
    stato?: VoucherStatus;
    version?: number;
}



